var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyPreferences = function SvgMyPreferences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#072C54",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10 13.324a2.919 2.919 0 1 0 0-5.838 2.919 2.919 0 0 0 0 5.838Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#072C54",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M16.84 10.405a7 7 0 0 0-.162-1.464l2.32-1.757-1.71-2.962-2.687 1.135a6.8 6.8 0 0 0-2.53-1.47L11.71 1H8.29l-.36 2.886a6.8 6.8 0 0 0-2.533 1.47L2.71 4.221 1 7.184 3.32 8.94a6.75 6.75 0 0 0 0 2.93L1 13.626l1.71 2.962 2.687-1.135a6.8 6.8 0 0 0 2.532 1.47l.36 2.887h3.421l.36-2.887a6.8 6.8 0 0 0 2.533-1.47l2.687 1.136L19 13.628l-2.319-1.758a7 7 0 0 0 .16-1.465Z"
  })));
};
export default SvgMyPreferences;